(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('ssoService', ssoService);

    /* @ngInject */
    function ssoService($http, $q, exception, logger, coreService) {
        var service = {
            getUserApplications: getUserApplications,
            getRequestAccessFields: getRequestAccessFields,
            sendRequestAccess: sendRequestAccess
        };

        activate();

        return service;

        function activate() {
        }

        function getUserApplications(userID) {
            return coreService.httpAccountsGet('Auth0/applicationMetadata/' + userID);
        }

        function getRequestAccessFields(applications, roles) {
            var userFields = [
                {
                    key: 'Email',
                    type: 'input',
                    templateOptions: {
                        type: 'Email',
                        label: 'Email',
                        placeholder: 'Email Address',
                        required: true
                    }
                },
              {
                  key: 'Applications',
                  type: 'ui-select-multiple',
                  templateOptions: {
                      optionsAttr: 'bs-options',
                      ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                      valueProp: 'ApplicationId',
                      labelProp: 'ApplicationName',
                      label: 'Applications',
                      placeholder: 'Applications',
                      options: applications,
                      required: true
                  }
              },
              {
                  key: 'Roles',
                  type: 'ui-select-multiple',
                  templateOptions: {
                      optionsAttr: 'bs-options',
                      ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                      valueProp: 'RoleId',
                      labelProp: 'RoleName',
                      label: 'Roles',
                      placeholder: 'Roles',
                      options: roles,
                      required: true,
                      groupBy: function(item) {
                            return item.Application.ApplicationName;
                      }
                  }
              }
            ];
            return userFields;
        }

        function sendRequestAccess(requestAccess) {
            return coreService.httpAccountsPost('Sso/requestAccess', requestAccess);
        }
    }
})();
